import React, { useState, useRef } from 'react'
import Modal from 'react-bootstrap-modal'

function ConfirmRefundModal({onClose, onSubmit}) {
  return <Modal container={document.body} show={true} onHide={onClose} className='sorting-modal '>
    <Modal.Header closeButton>
      <Modal.Title>Refund Confirmation</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className='textarea text-center'>
        Are you sure you want to refund this player's payment? This action cannot be undone.
      </div>
      <div className='form-group'>
        <div className='col-sm-6 text-center'>
          <button className='btn btn-default' onClick={onClose}>Cancel</button>
        </div>
        <div className='col-sm-6 text-center'>
          <button className='btn btn-primary' onClick={onSubmit}>Send Refund</button>
        </div>
      </div>
    </Modal.Body>
  </Modal>
}

export default ConfirmRefundModal
